<div class="d-md-flex align-items-center bg-white p-3">
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14">{{'listino.title' | translate}}</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
  <div class="ml-auto mt-3 mt-md-0" >
    <button type="button" class="btn btn-warning rounded-pill py-2" (click)='Eliminati()'><i
      class="fas fa-ban font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{ShowAll ? ('listino.hide'|translate) : ('listino.show'|translate)}}</span>
    </button>
    <button type="button" class="btn btn-info rounded-pill py-2" (click)='ImportaListini()' ><i
      class="fas fa-download font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'listino.import.title' | translate}}</span>
    </button>
<!--    <button type="button" class="btn btn-info rounded-pill py-2" (click)='ImportaDefault()' ><i-->
<!--      class="fas fa-download font-14 mr-1 text-white"></i>-->
<!--      <span class="ml-1 text-white font-weight-bold">{{'listino.importdefault' | translate}}</span>-->
<!--    </button>-->
    <button type="button"  class="btn btn-cyan rounded-pill py-2" (click)='AddListino()'><i
      class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'listino.add' | translate}}</span>
    </button>
  </div>
</div> <!--bottoni-->
<div class="d-md-flex align-items-center border-top bg-white p-3 ">
  <div class="input-group">
    <div class="input-group col-lg-9 " style="margin-bottom: 10px;">
      <div class="input-group-prepend">
        <label class="input-group-text" for="fornitore">{{'listino.fornitore' | translate}}</label>
      </div>
      <input type="text" id="fornitore" class="form-control" [(ngModel)]="filtri.fornitore" (ngModelChange)="Refresh()">
    </div>
    <div class="input-group col-lg-3 " style="margin-bottom: 10px;">
      <div class="input-group-prepend">
        <label class="input-group-text" for="last">{{'listino.last' | translate}}</label>
      </div>
      <input type="checkbox" id="last" class="form-control" [(ngModel)]="filtri.last" (ngModelChange)="Refresh()">
    </div>
  </div>
</div> <!--filtri-->
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
    <tr>
      <th scope="col">{{'listino.fornitore' | translate}}</th>
      <th scope="col">{{'listino.data' | translate}}</th>
      <th scope="col">{{'listino.azioni' | translate}}</th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of Lista | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td class="align-middle">
          {{item?.nominativo}}
        </td>
        <td class="align-middle">
          {{item?.data | date: 'dd/MM/yyyy'}}
        </td>
        <td class="align-middle">
          <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2" (click)='EditListino(item)'>
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a *ngIf="item?.enabled" href="javascript:void(0)" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
             (click)='Delete(item)'>
            <i class="fas fa-trash-alt"></i>
          </a>
          <a *ngIf="!item?.enabled" href="javascript:void(0)" ngbTooltip="Restore" class="link text-orange font-16 font-weight-bold" (click)='Restore(item)'>
            <i class="fas fa-plus"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
                  [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
